import { render, staticRenderFns } from "./r-reward-generator-mode.vue?vue&type=template&id=3a7d563e"
import script from "./r-reward-generator-mode.vue?vue&type=script&lang=js"
export * from "./r-reward-generator-mode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a7d563e')) {
      api.createRecord('3a7d563e', component.options)
    } else {
      api.reload('3a7d563e', component.options)
    }
    module.hot.accept("./r-reward-generator-mode.vue?vue&type=template&id=3a7d563e", function () {
      api.rerender('3a7d563e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/reward-generator/r-reward-generator-mode.vue"
export default component.exports